import { OreHeading, OreStack, OreStepper } from "@edenredespana/oreneta"
import { LoginTranslation } from "../accountTranslation"
import { useTranslation } from "react-i18next"
import { RegisterSteps } from "@/Account/domain"
import { RegisterStepThree } from "../molecules/RegisterStepThree"

export const StepThree = (): JSX.Element => {
  const { t } = useTranslation()
  return (
    <OreStack space="large" placeContent="stretch" style={{ maxWidth: '50%' }}>
      <OreHeading as="h1" size="headline-lg">
        {t(LoginTranslation.register.heading)}
      </OreHeading>
      <>
        <OreStepper
          activeStep={RegisterSteps.Access}
          steps={[
            t(LoginTranslation.register.step1),
            t(LoginTranslation.register.step2),
            t(LoginTranslation.register.step3),
          ]}
        />
        <RegisterStepThree />
      </>
    </OreStack>
  )
}